(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-origin-disclosure')) {
    customElements.define('custom-origin-disclosure', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        const button = this.querySelector('[data-disclosure-button]');
        if (!button) return;

        this.dataset.ready = 'true';
        button.addEventListener('click', () => {
          const expanded = this.dataset.expanded !== 'true';
          this.dataset.expanded = String(expanded);
          button.setAttribute('aria-expanded', String(expanded));
          button.querySelector('[data-label-collapsed]').hidden = expanded;
          button.querySelector('[data-label-expanded]').hidden = !expanded;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-origin-discount-offer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-origin-copy-code')) {
    customElements.define('custom-origin-copy-code', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;

        const button = this.querySelector('[data-copy-button]');
        const label = this.querySelector('[data-copy-label]');
        const status = this.querySelector('[data-copy-status]');
        if (!button || !label || !status) return;

        this.dataset.ready = 'true';
        button.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(button.dataset.code);
            label.textContent = button.dataset.copiedLabel;
            button.setAttribute('aria-label', button.dataset.copiedLabel);
            status.textContent = button.dataset.copiedLabel;
            window.setTimeout(() => {
              label.textContent = button.dataset.copyLabel;
              button.setAttribute('aria-label', button.dataset.copyLabel);
              status.textContent = '';
            }, 2500);
          } catch (error) {
            status.textContent = button.dataset.errorLabel;
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
